import InnoFindVue from "../InnoFindVue";

export default class InnoFindWidgetAgent extends InnoFindVue {
  public findAllProductTiles(): HTMLElement[] {
    return [...document.querySelectorAll<HTMLElement>("[data-producttile]")];
  }
}
